import moment from 'moment';
import { useStore } from 'effector-react';
import { $authorizedUser } from '@containers/store/states';
import { TaskDeliverableType } from 'dy-frontend-http-repository/lib/data/enums';
import { CreateTaskDeliverablesInput } from 'dy-frontend-http-repository/lib/modules/TaskDeliverable/inputs';
import { TaskDeliverableResource } from 'dy-frontend-http-repository/lib/modules/TaskDeliverable/resources';
import TaskDeliverableRefList from 'dy-frontend-http-repository/lib/modules/TaskDeliverable/refs/TaskDeliverableRefList';
import { createTaskDeliverablesBatch } from '../../store/effects';
import { taskDeliverablesTreeApi } from '../../store/apis';

const useCreateTextTaskDeliverable = () => {
    const authorizedUser = useStore($authorizedUser);

    const handleCreateTextTaskDeliverable = async ({
        taskId,
        path,
        title,
        textContent,
    }: {
        taskId: ID;
        path: string;
        title: string;
        textContent: string;
    }): Promise<TaskDeliverableRefList> => {
        if (!authorizedUser) {
            // TODO: handle error
            throw new Error('user is not authorized');
        }

        // Create input
        const createTaskDeliverablesBatchInputItem: CreateTaskDeliverablesInput['items'][number] = {
            path,
            type: TaskDeliverableType.TEXT,
            title,
            text_content: textContent,
        };

        try {
            const createTaskDeliverablesBatchResponse = await createTaskDeliverablesBatch({
                task_id: taskId,
                items: [createTaskDeliverablesBatchInputItem],
            });

            // Create task deliverable
            const momentDateNowFormatted = moment().utc().format();
            const taskDeliverable: TaskDeliverableResource = {
                id: createTaskDeliverablesBatchResponse.ids[0],
                task_id: taskId,
                approved_at: null,
                archived_at: null,
                replaced_at: null,
                parent_task_deliverable: null,
                created_at: momentDateNowFormatted,
                title: createTaskDeliverablesBatchInputItem.title!,
                path: createTaskDeliverablesBatchInputItem.path,
                type: createTaskDeliverablesBatchInputItem.type,
                text_content: createTaskDeliverablesBatchInputItem.text_content!,
                url: '',
                file: null,
                user: {
                    id: authorizedUser.user.id,
                    first_name: authorizedUser.user.first_name,
                    last_name: authorizedUser.user.last_name,
                    image_hash: authorizedUser.user.image_hash,
                },
            };

            // Insert task deliverables data
            taskDeliverablesTreeApi.insert({ taskDeliverables: [taskDeliverable] });

            return createTaskDeliverablesBatchResponse;
        } catch (e) {
            throw e;
        }
    };

    return { createTextTaskDeliverable: handleCreateTextTaskDeliverable };
};

export default useCreateTextTaskDeliverable;
